"use client";

import { Box, HStack, Text } from "@chakra-ui/react";
import GenericSegment from "@/shared/ui/controls/GenericSegment";
import WithBreadcrumb from "@/shared/ui/navigation/WithBreadcrumb";
import WithBreadcrumbItem from "@/shared/ui/navigation/WithBreadcrumbItem";
import type { ThoughtGrouping } from "@/generated/fastapi";
import { SEGMENT_LABEL_PROPS } from "./studioChrome.constants";
import type {
  StudioGroupingOption,
  StudioPrototypeTone,
} from "./studioChrome.types";

type StudioGroupingControlProps = {
  activeStudioGrouping: ThoughtGrouping;
  options: StudioGroupingOption[];
  disabled?: boolean;
  tone: StudioPrototypeTone;
  onStudioGroupingChange: (value: ThoughtGrouping) => void;
};

export default function StudioGroupingControl({
  activeStudioGrouping,
  options,
  disabled = false,
  tone,
  onStudioGroupingChange,
}: StudioGroupingControlProps) {
  return (
    <>
      <Box display={{ base: "block", md: "none" }}>
        <WithBreadcrumb>
          <WithBreadcrumbItem<ThoughtGrouping>
            activeState={activeStudioGrouping}
            setActiveState={onStudioGroupingChange}
            options={options}
            minWidth="9rem"
            indicatorIcon="expand_more"
            indicatorIconColor={tone.accent}
            disabled={disabled}
          />
        </WithBreadcrumb>
      </Box>

      <HStack
        display={{ base: "none", md: "flex" }}
        gap="3"
        align="center"
        flexWrap="wrap"
      >
        <Text {...SEGMENT_LABEL_PROPS}>Grouping</Text>
        <Box minW={0}>
          <GenericSegment<ThoughtGrouping>
            activeState={activeStudioGrouping}
            setActiveState={onStudioGroupingChange}
            options={options}
            size="md"
            disabled={disabled}
          />
        </Box>
      </HStack>
    </>
  );
}
